module.exports = __webpack_public_path__ + "img/zi.24296d39.png";